import type { RouteRecordRaw } from 'vue-router';
import VirtualColleagueView from '@views/Settings/VirtualColleague/VirtualColleagueView.vue';
import AIView from '@views/Settings/VirtualColleague/AI/AIView.vue';
import SourcesView from '@views/Settings/VirtualColleague/AI/SourcesView.vue';
import RuleListView from '@views/Settings/VirtualColleague/AI/Rules/RuleListView.vue';
import RuleDetailView from '@views/Settings/VirtualColleague/AI/Rules/RuleDetailView.vue';

const routes: RouteRecordRaw[] = [
    {
        path: 'virtual-colleague',
        name: 'settings-virtual-colleague',
        components: {
            default: VirtualColleagueView,
        },
        children: [
            {
                path: 'ai',
                name: 'settings-virtual-colleague-ai',
                components: {
                    default: AIView,
                },
                redirect: { name: 'settings-virtual-colleague-ai-rules' },
                // redirect: { name: 'settings-virtual-colleague-ai-sources' },
                children: [
                    {
                        path: 'sources',
                        name: 'settings-virtual-colleague-ai-sources',
                        components: {
                            default: SourcesView,
                        },
                    },
                    {
                        path: 'rules',
                        name: 'settings-virtual-colleague-ai-rules',
                        components: {
                            default: RuleListView,
                        },
                        children: [
                            {
                                path: 'create',
                                name: 'settings-virtual-colleague-ai-rules-create',
                                components: {
                                    default: RuleDetailView,
                                },
                            }, {
                                path: 'edit/:ruleId',
                                name: 'settings-virtual-colleague-ai-rules-edit',
                                components: {
                                    default: RuleDetailView,
                                },
                            },
                        ],
                    },
                ],
            },
        ],
    },
];

export default routes;
